import { Search } from "lucide-react";

const ProjectSearch = ({ search, setSearch }) => {
  return (
    <div className="relative w-full md:w-80 lg:w-96">
      {/* Search Icon */}
      <Search
        size={18}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
      />

      {/* Search Input */}
      <input
        type="text"
        value={search}
        placeholder="Search project by name or code..."
        onChange={(e) => setSearch(e.target.value)}
        className="
          w-full
          pl-10
          pr-4
          py-2.5
          border
          border-gray-300
          rounded-lg
          bg-white
          text-sm
          placeholder:text-gray-400
          focus:outline-none
          focus:ring-2
          focus:ring-blue-500
          focus:border-blue-500
          transition
        "
      />
    </div>
  );
};

export default ProjectSearch;